import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ProcesadoraComponent } from '../procesadora/procesadora.component';
import { ModuloItemComponent } from './components/modulo-item/modulo-item.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    ProcesadoraComponent,
    ModuloItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ModuloItemComponent]
})
export class PageModulesModule { }
